import React from 'react';
import { Alert as AntdAlert } from 'components/antd';
import ListAlert from 'components/ListAlert/ListAlert';
import { RootStore, AlertStore } from 'AppClient/stores';
import { observer, inject } from 'mobx-react';

interface Props {
	alertStore?: AlertStore;
}
const AlertContainer: React.FC<Props> = props => {
	const {
		clearAlert,
		alert: { type, message },
	} = props.alertStore!;
	if (!message) {
		return null;
	}
	const getMessage = () => {
		if (Array.isArray(message)) {
			return <ListAlert errors={message} isPassword />;
		}
		return message;
	};
	return (
		<AntdAlert
			type={type}
			message={getMessage()}
			closable
			showIcon
			autoClose
			resetAlert={clearAlert}
		/>
	);
};

export const Alert = inject(({ alertStore }: RootStore) => ({ alertStore }))(
	observer(AlertContainer)
);
